const errors = {
  en: {
    // General error
    1000: `
      It seems like something went wrong. Please try to reload your browser.<br><br>
      Should this error still occur you can always reserve tickets via <a href="tel:+49403006800">+49 40 3006800</a>.<br><br>
      If you are using an adblocker, please turn it off.
    `,

    // Invalid Order
    1496305860: 'This order requires payment and is therefore not valid with payment method "cash".',
    1496305865: 'This order does not require payment and must be created with payment_method "cash".',
    1496305874: 'Order contains more reservations than the allowed maximum.',
    1496305880: 'Invalid number of reservations.',
    1496305887: 'Invalid number of tickets.',
    1496305893: 'Order contains more tickets than the allowed maximum.',
    1496305904: 'Reservation is in the past or not long enough from time of order,',
    1496305908: 'Ticket order is in the past or not long enough from time of order.',
    1496305918: 'The order doesn\'t contain any items.',
    1496305924: 'An order containing vouchers must also contain tickets.',
    1496816969: 'Please note: Infants need a companion.',
    1497530750: 'Payment did not succeed.',
    1497620385: 'The selected time slot of arrival is not available. Please chose a different time slot.',
    1497620386: 'The selected time slot of arrival is not (any longer) available on your selected date. Please chose a different time slot or a day.',
    1498138140: 'An order must not contain tickets and reservations at the same time.',
    1501230238: 'Your order does not contain any articles.',
    1646223330: 'Your order contains combo-tickets but no entrance tickets. Please select entrance tickets or change your tickets to regular tickets.',
    tours_invalid_number: 'Invalid number of experiences.',
    tours_limit_reached: 'Order contains more experiences than the allowed maximum.',
    tickets_for_gap_not_available: 'The requested amount of tickets is no longer available for this gap. Please choose tickets for another gap.',
    minimum_tickets_not_reached: 'The requested amount of tickets is below the minimum amount. Please choose more tickets for this time slot.'
  },
  de: {
    // General error
    1000: `
      Es scheint ein Fehler aufgetreten zu sein. Bitte laden Sie die Seite erneut.<br><br>
      Sollte der Fehler weiterhin auftreten, können Sie Tickets auch telefonisch unter <a href="tel:+49403006800">040 3006800</a> reservieren.<br><br>
      Wenn Sie einen Adblocker verwenden, schalten Sie ihn bitte aus.
    `,

    // Invalid Order
    1496305860: 'Bitte geben Sie eine andere Zahlungsart als "cash" an.',
    1496305865: 'Diese Bestelung bedarf keiner Bezahlung. Bitte geben Sie "cash" als Zahlart an.',
    1496305874: 'Die Bestellung enthält mehr Reservierungen als erlaubt.',
    1496305880: 'Ungültige Anzahl von Reservierungen.',
    1496305887: 'Ungültige Anzahl von Karten.',
    1496305893: 'Die Bestellung enthält mehr Karten als erlaubt.',
    1496305904: 'Die Reservierung liegt in der Vergangenheit oder nicht weit genug in der Zukunft.',
    1496305908: 'Die Bestellung liegt in der Vergangenheit oder nicht weit genug in der Zukunft.',
    1496305918: 'Die Bestellung enthält keine Karten.',
    1496305924: 'Eine Bestellung mit Gutscheinen muss auch Karten enthalten.',
    1496816969: 'Bitte beachten: Kleinkinder brauchen eine Begleitperson.',
    1497530750: 'Die Zahlung ist fehlgeschlagen.',
    1497620385: 'Die gewählte Ankunftszeit ist nicht verfügbar. Bitte wählen Sie eine andere Ankunftszeit aus.',
    1497620386: 'Die gewählte Ankunftszeit ist an dem aktuell ausgewählten Tag nicht (mehr) verfügbar. Bitte wählen Sie eine andere Ankunftszeit oder einen anderen Tag aus.',
    1498138140: 'Eine Bestellung kann nicht Tickets und Reservierungen gleichzeitig enthalten.',
    1501230238: 'Ihre Bestellung enthält keine Artikel.',
    1646223330: 'Ihre Bestellung enthält Kombi-Tickets, aber keine dazugehörigen Eintrittskarten. Bitte wählen Sie zusätzlich Eintrittskarten oder wechseln sie zu regulären Ticekts.',
    tours_invalid_number: 'Ungültige Anzahl an Erlebnissen.',
    tours_limit_reached: 'Die Bestellung enthält mehr Erlebnisse als erlaubt.',
    tickets_for_gap_not_available: 'Die gewünschte Anzahl von Tickets ist für diese Uhrzeit nicht mehr verfügbar. Bitte wählen Sie Tickets für eine andere Uhrzeit.',
    minimum_tickets_not_reached: 'Die gewünschte Anzahl von Tickets unterschreitet die Mindestanzahl. Bitte wählen Sie mehr Tickets für diesen Zeitraum.'
  }
}

/**
 * Get error object
 * @param {'en'|'de'} language Language code
 * @returns {Object<number, string>} Errors
 */
export default function (language) {
  return errors[language]
}
